import { render, staticRenderFns } from "./expert-review.vue?vue&type=template&id=b695ff0c&scoped=true"
import script from "./expert-review.vue?vue&type=script&lang=js"
export * from "./expert-review.vue?vue&type=script&lang=js"
import style0 from "./expert-review.vue?vue&type=style&index=0&id=b695ff0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b695ff0c",
  null
  
)

export default component.exports